import axios from 'axios';

export const getAsset = async (assetId) => {
  if (!assetId) return null;
  const apiUrl = `https://mainnet-idx.algonode.cloud/v2/assets/${assetId}`;
  const { data } = await axios.get(apiUrl);
  return data?.asset;
};
